export default "__VITE_ASSET__CNx0dy7W__"